import * as React from "react";

import { cn } from "@/lib/utils";

// forwardRef: no React 18 o `ref` não passa como prop; sem isso o react-hook-form não foca o campo com erro.
const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<"textarea">>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      data-slot="textarea"
      className={cn(
        // Base
        "field-sizing-content flex min-h-16 w-full rounded-md border border-input px-3 py-2 text-base shadow-sm outline-none transition-[color,box-shadow] md:text-sm",

        // Cores (Fundamental para Dark Mode)
        "bg-transparent text-foreground placeholder:text-muted-foreground",

        // Dark Mode específico (Mantido seu estilo original que dá um brilho sutil no input)
        "dark:bg-input/30",

        // Focus State
        "focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/50",

        // Disabled State
        "disabled:cursor-not-allowed disabled:opacity-50",

        // Error State (Aria Invalid)
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",

        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";

export { Textarea };
